import { Component, ChangeDetectionStrategy } from '@angular/core';
import * as moment from 'moment';

import { MicrobiologyData } from './microbiology-data';
import { DataRevisionIndicator } from '../../shared';

@Component({
    selector: 'culture-details-cell',
    template: require('./culture-details-ag-renderer.component.html'),
    styles: [require('./culture-details-ag-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CultureDetailsAgRendererComponent {
    public readonly noDataText = 'No susceptibility data';
    public data: CultureRow;
    public resultDataRevisionMessage: string;

    constructor(private dataRevisionIndicator: DataRevisionIndicator) {
        this.resultDataRevisionMessage = dataRevisionIndicator.resultDataRevisionMessage;
    }

    public agInit(row: { data: CultureRow }): void {
        this.data = row.data;
    }
}

export interface CultureRow {
    subject: string;
    visitDescription: string;
    testGroupName: string;
    specimen: string;
    growthDetails: GrowthDetails;
    textDetails: TextDetails;
    cancellationReason: string;
    isCancelled: boolean;
    hasSubjectDataRevision: boolean;
    hasVisitDataRevision: boolean;
    hasSpecimenDataRevision: boolean;
    dataChangeDetails?: DataChangeDetails;
}

export interface GrowthDetails {
    growth: string;
    organism: string;
    order: number;
    hasGrowthResultDataRevision: boolean;
    hasOrganismResultDataRevision: boolean;
    agents: MicrobiologyData[];
}

export interface DataChangeDetails {
    microTestId: number;
    subjectNumber: string;
    accessionNumber: string;
    visitDescription: string;
}

export interface TextDetails {
    title: string;
    value: string;
    hasTestResultDataRevision: boolean;
    isQuestion: boolean;
    isCancelled: boolean;
    testCollectionDateTime: moment.Moment; 
    testAccessionId: number;
    testSequence: number;
    sequence: number;
}